import Hero from "@/components/site/Hero";
import AboutSection from "@/components/site/AboutSection";
import ServicesGrid from "@/components/site/ServicesGrid";
import NotariusBanner from "@/components/site/NotariusBanner";
import VardnadtvistSpotlight from "@/components/site/VardnadtvistSpotlight";
import Testimonials from "@/components/site/Testimonials";
import BlogPreview from "@/components/site/BlogPreview";
import ContactForm from "@/components/site/ContactForm";
import { useSEO } from "@/lib/seo";

export default function Home() {
    useSEO({
        title: "Juristbyrå i Sverige",
        description:
            "BM Juridik är en etablerad juristbyrå med kontor i Stockholm, Göteborg, Malmö, Uppsala, Jönköping och Herrljunga — bred kompetens inom tolv rättsområden.",
        image: "https://images.pexels.com/photos/6077430/pexels-photo-6077430.jpeg",
    });
    return (
        <div data-testid="page-home">
            <Hero />
            <AboutSection />
            <ServicesGrid />
            <NotariusBanner />
            <VardnadtvistSpotlight />
            <Testimonials />
            <BlogPreview />
            <ContactForm />
        </div>
    );
}
